const extractEntries: <X extends string, Y>(o: Record<X, Y>) => Array<{ key: X, value: Y }> = (o) => {
  type X = keyof typeof o;
  const keys = Object.keys(o).map(key => key as X);
  return keys.map(key => ({ key, value: o[key] }));
};

export default extractEntries;
